import React, { Component } from "react";
import "./badge.scss";

class Badge extends Component {
  render() {
    const { text, level } = this.props;
    let className = "redcircle-badge";
    if (level === "error") {
      className += " redcircle-badge-error";
    }
    return <span className={className}>{text}</span>;
  }
}

export default Badge;
